<template>
  <div class="floating-buttons" v-show="!isAdminRoute">
    <!-- 微信按钮 -->
    <div class="wechat-button" @mouseenter="showQrCode = true" @mouseleave="showQrCode = false">
      <div class="wechat-icon"></div>
      <!-- 二维码弹出层 -->
      <div class="qrcode-popup" v-show="showQrCode">
        <img :src="qrcodeData.preview_url" alt="QR Code" class="qrcode-image">
        <p>{{ qrcodeData.text || '扫一扫添加客服' }}</p>
      </div>
    </div>

    <!-- 返回顶部按钮 -->
    <div class="back-to-top" v-show="showBackToTop" @click="scrollToTop">
      <div class="arrow-icon"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import { useRoute } from 'vue-router'

const backendUrl = ref(import.meta.env.VITE_JAVA_API_URL)


const route = useRoute()
const showQrCode = ref(false)
const showBackToTop = ref(false)
const isAdminRoute = computed(() => route.path.startsWith('/admin'))

// 添加二维码数据状态
const qrcodeData = ref({
  image_url: '/icons/qrcode.jpg', // 默认值
  preview_url: '',
  text: '扫一扫添加客服'  // 默认值
})

// 获取二维码数据
const fetchQrcode = async () => {
  try {
    const response = await fetch(`${backendUrl.value}/system/qrcode/getQrCode`)
    if (response.ok) {
      const data = await response.json()
      if (data.data.image_url) {
        qrcodeData.value = data.data
      }
    }
  } catch (error) {
    console.error('获取二维码数据失败:', error)
  }
}

// 监听滚动事件
const handleScroll = () => {
  showBackToTop.value = window.scrollY > 300
}

// 返回顶部
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
}

onMounted(async () => {
  await fetchQrcode()
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<style scoped>
.floating-buttons {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.wechat-button {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wechat-button:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}

.wechat-icon {
  width: 32px;
  height: 32px;
  background-image: url('/feishulogo.png');
  background-size: 32px;
  /* background-color: #07C160; */
  /* mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath d='M692.3 347.2c11.2 0 22.3.8 33.2 2.1-29.8-138.9-178.2-242.1-347.5-242.1-189.4 0-345.3 129.3-345.3 292.7 0 94.5 51.6 172.1 137.7 232.3l-34.4 103.5 120.3-60.2c43 8.5 77.5 17.2 120.7 17.2 10.8 0 21.5-.5 32.1-1.4-6.7-23-10.6-47.1-10.6-72.1 0-150.4 129.3-272 293.8-272zM500.9 248.4c25.9 0 43.1 17.2 43.1 43.1s-17.2 43.1-43.1 43.1c-25.9 0-51.8-17.2-51.8-43.1.1-25.9 25.9-43.1 51.8-43.1zM284.8 334.6c-25.9 0-51.8-17.2-51.8-43.1s25.9-43.1 51.8-43.1c25.9 0 43.1 17.2 43.1 43.1s-17.2 43.1-43.1 43.1zM1024 629.4c0-137.7-137.7-250.6-292.7-250.6-163.6 0-292.7 112.9-292.7 250.6 0 138 129.1 250.6 292.7 250.6 34.4 0 68.8-8.7 103.2-17.2l94.5 51.8-25.9-86.2c69.1-51.8 120.9-120.6 120.9-198.4zM614.8 586.3c-17.2 0-34.4-17.2-34.4-34.4s17.2-34.4 34.4-34.4c25.9 0 43.1 17.2 43.1 34.4 0 17.2-17.2 34.4-43.1 34.4zm181.9 0c-17.2 0-34.4-17.2-34.4-34.4s17.2-34.4 34.4-34.4c25.9 0 43.1 17.2 43.1 34.4 0 17.2-17.2 34.4-43.1 34.4z'/%3E%3C/svg%3E") no-repeat center; */
  /* -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1024 1024'%3E%3Cpath d='M692.3 347.2c11.2 0 22.3.8 33.2 2.1-29.8-138.9-178.2-242.1-347.5-242.1-189.4 0-345.3 129.3-345.3 292.7 0 94.5 51.6 172.1 137.7 232.3l-34.4 103.5 120.3-60.2c43 8.5 77.5 17.2 120.7 17.2 10.8 0 21.5-.5 32.1-1.4-6.7-23-10.6-47.1-10.6-72.1 0-150.4 129.3-272 293.8-272zM500.9 248.4c25.9 0 43.1 17.2 43.1 43.1s-17.2 43.1-43.1 43.1c-25.9 0-51.8-17.2-51.8-43.1.1-25.9 25.9-43.1 51.8-43.1zM284.8 334.6c-25.9 0-51.8-17.2-51.8-43.1s25.9-43.1 51.8-43.1c25.9 0 43.1 17.2 43.1 43.1s-17.2 43.1-43.1 43.1zM1024 629.4c0-137.7-137.7-250.6-292.7-250.6-163.6 0-292.7 112.9-292.7 250.6 0 138 129.1 250.6 292.7 250.6 34.4 0 68.8-8.7 103.2-17.2l94.5 51.8-25.9-86.2c69.1-51.8 120.9-120.6 120.9-198.4zM614.8 586.3c-17.2 0-34.4-17.2-34.4-34.4s17.2-34.4 34.4-34.4c25.9 0 43.1 17.2 43.1 34.4 0 17.2-17.2 34.4-43.1 34.4zm181.9 0c-17.2 0-34.4-17.2-34.4-34.4s17.2-34.4 34.4-34.4c25.9 0 43.1 17.2 43.1 34.4 0 17.2-17.2 34.4-43.1 34.4z'/%3E%3C/svg%3E") no-repeat center; */
  transition: background-color 0.3s ease;
}

.wechat-button:hover .wechat-icon {
  /* background-color: #06AE56; */
}

.qrcode-popup {
  position: absolute;
  right: 60px;
  bottom: 0;
  background: white;
  padding: 16px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 180px;
  transform-origin: right center;
  animation: popIn 0.3s ease;
}

@keyframes popIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateX(10px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateX(0);
  }
}

.qrcode-popup::after {
  content: '';
  position: absolute;
  right: -8px;
  top: 50%;
  transform: translateY(-50%);
  border-left: 8px solid white;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
}

.qrcode-image {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
  margin-bottom: 12px;
}

.qrcode-popup p {
  margin: 0;
  font-size: 16px;
  color: #333;
  font-weight: 500;
  text-align: center;
}

.back-to-top {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.back-to-top:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(0,0,0,0.15);
}

.arrow-icon {
  width: 20px;
  height: 20px;
  background-color: #666666;
  mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 4l-8 8h6v8h4v-8h6z'/%3E%3C/svg%3E") no-repeat center;
  -webkit-mask: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M12 4l-8 8h6v8h4v-8h6z'/%3E%3C/svg%3E") no-repeat center;
  transition: background-color 0.3s ease;
}

.back-to-top:hover .arrow-icon {
  background-color: #333333;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .floating-buttons {
    right: 16px;
    bottom: 16px;
    gap: 12px;
  }

  .wechat-button,
  .back-to-top {
    width: 40px;
    height: 40px;
  }

  .wechat-icon {
    width: 24px;
    height: 24px;
  }

  .arrow-icon {
    width: 16px;
    height: 16px;
  }

  .qrcode-popup {
    width: 160px;
    padding: 12px;
  }

  .qrcode-image {
    width: 130px;
    height: 130px;
  }
}
</style>